import { Stack } from "@vapor/react-material";
import React, { useCallback, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { BusinessSectionalsForm } from "../../../../../../components/form/business/sectionals";
import { useGetAdditionalBusinessDetails } from "../../../../../../hooks/api/business/useGetAdditionalBusinessDetails";
import { useGetBusiness } from "../../../../../../hooks/api/business/useGetBusiness";

import { BoxSkeleton } from "../../../skeletons/boxskeleton";
import { Feedback } from "../../../../../../@types/enums/general/Feedback";
import WsSnackbar, { WsSnackbarTypes } from "../../../../../../components/ws-snackbar";
import { useTranslation } from "@onefront/react-sdk";

export const BusinessSectionals = ({ setBusiness }) => {
    const { t } = useTranslation();
    const { workspaceId, businessId } = useParams();
    const navigate = useNavigate();
    const [items, setItems] = useState<any>([]);
    const [isEditing, setIsEditing] = useState<any>(null);
    const [feedback, setFeedback] = useState<any>(null);

    const { data: business, loading: loadingGet, fetch: getBusiness } = useGetBusiness(workspaceId, businessId);

    const {
        data: sectionals,
        loading: loadingSectionals,
        fetch: getSectionals
    } = useGetAdditionalBusinessDetails(workspaceId, businessId, "sectionals");

    const handleSave = useCallback((data: any) => {
        setIsEditing(null);
        getSectionals?.();
        setFeedback(Feedback.SUCCESS);
        if (data?.main) {
            window.scrollTo(0, 0);
        }
    }, []);

    useEffect(() => {
        if (businessId && !business && !loadingGet) {
            getBusiness?.().then(res => {
                setBusiness(res?.data);
            });
        }
    }, [businessId, getBusiness, business, loadingGet, setBusiness]);

    useEffect(() => {
        if (sectionals?.length > 0) {
            setItems(
                sectionals
                    ?.sort((a, b) => b.reverseCharge - a.reverseCharge)
                    ?.sort((a, b) => b.main - a.main)
                    ?.map(item => {
                        return {
                            ...item,
                            id: item?.id,
                            idSectional: item?.id
                        };
                    })
            );
            setIsEditing(null);
        } else {
            setItems([]);
            setIsEditing(null);
        }
    }, [sectionals]);

    return (
        <Stack position={"relative"} width={768}>
            {feedback && (
                <WsSnackbar
                    position={"absolute"}
                    sx={{
                        right: "0 !important",
                        top: "-4.5rem !important",
                        width: 700
                    }}
                    type={
                        [Feedback.ERROR, Feedback.INCOMPLETE]?.indexOf(feedback) > -1
                            ? WsSnackbarTypes.error
                            : WsSnackbarTypes.success
                    }
                    title={t(`business.sectionals.title`)}
                    message={t(`feedback.sectionals.edit.${feedback}`)}
                    horizontal="right"
                    handleClose={() => setFeedback(null)}
                />
            )}
            {sectionals ? (
                <BusinessSectionalsForm
                    businessData={{ sectionals: sectionals }}
                    items={items}
                    setItems={setItems}
                    isEditing={isEditing}
                    setIsEditing={setIsEditing}
                    isNewBusiness={true}
                    onForward={() => {
                        if (items?.length === 0) {
                            setFeedback(Feedback.INCOMPLETE);
                            return null;
                        }
                        navigate(`/details/${workspaceId}/business/wizard/${businessId}/vatconfiguration`);
                    }}
                    onBack={() => {
                        navigate(`/details/${workspaceId}/business/wizard/${businessId}/accounting`);
                    }}
                    onReset={() => {
                        getSectionals?.();
                    }}
                    onSave={handleSave}
                    loading={loadingSectionals}
                    isCeasedBusiness={false}
                />
            ) : (
                <BoxSkeleton n={3} />
            )}
        </Stack>
    );
};
